import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppState } from 'src/store/appstate';
import { TimezoneEntityFetchService } from 'src/store/generated/client-sync.generated';
import {
  selectTimezoneEntitiesByCode,
  TimezoneProps,
  TimezoneRecord,
  TimezoneViewModelBase,
} from 'src/store/generated/timezone-record.generated';

export class TimezoneViewModel extends TimezoneViewModelBase {
  constructor(props: TimezoneProps) {
    super(props);
  }
}

@Injectable({ providedIn: 'root' })
export class TimezoneViewModelService {
  constructor(
    private readonly _timezoneEntityFetchService: TimezoneEntityFetchService,
    private readonly store: Store<AppState>,
  ) {}

  public getById(id: string): Observable<TimezoneViewModel | undefined> {
    return this._timezoneEntityFetchService.getById(id).pipe(
      map((timezone) => {
        if (timezone == null) {
          return undefined;
        }
        return new TimezoneViewModel(timezone);
      }),
    );
  }

  public getTimezoneByCode(timezoneCd: string): Observable<TimezoneViewModel | undefined> {
    return this.store.select(selectTimezoneEntitiesByCode(timezoneCd)).pipe(
      map((zones) => {
        const tz = zones.first<TimezoneRecord>(undefined);
        return tz != null ? new TimezoneViewModel(tz) : tz;
      }),
    );
  }
}
